import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface MenuState {
  liveMenuCard: any[]
}

const initialState: MenuState = {
  liveMenuCard: []
}

export const menuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    setLiveMenuCard: (state, action: PayloadAction<any[]>) => {
      state.liveMenuCard = action.payload
    },
    clearLiveMenuCard: (state) => {
      state.liveMenuCard = []
    }
  }
})

export const { setLiveMenuCard, clearLiveMenuCard } = menuSlice.actions
export default menuSlice.reducer
